import { createTRPCClient, httpBatchLink } from '@trpc/client'

// biome-ignore lint/style/useImportType: keep top-level `import type` (not inline) so Vite fully elides it and does not bundle the api router runtime into the client
import type { AppRouter } from '@langmail/api/trpc'

const getServerUrl = (): string => import.meta.env.VITE_SERVER_URL || ''

// Send the cross-subdomain Better Auth session cookie with every request.
const fetchWithCredentials = (url: URL | RequestInfo, options?: RequestInit): Promise<Response> =>
  fetch(url, { ...options, credentials: 'include' })

// tRPC client for React components (via TRPCProvider)
export const trpcClient = createTRPCClient<AppRouter>({
  links: [
    httpBatchLink({
      url: `${getServerUrl()}/trpc`,
      fetch: fetchWithCredentials,
    }),
  ],
})
